var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "homePageWarp" },
    [
      _c(
        "div",
        {
          class: {
            navHdWarp:
              _vm.hdColor == 0 ||
              _vm.hdColor == 1 ||
              _vm.hdColor == 2 ||
              _vm.hdColor == 3,
            navNewsDetail: _vm.hdColor == 0,
            redHeader: _vm.hdColor == 1,
            blueHeader: _vm.hdColor == 2,
            purpleHeader: _vm.hdColor == 3,
          },
        },
        [
          _c("div", { staticClass: "navHd" }, [
            _c(
              "div",
              {
                staticClass: "logo",
                on: {
                  click: function ($event) {
                    return _vm.goPath("/", "首页")
                  },
                },
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", [
                  _vm.isBack
                    ? _c(
                        "div",
                        {
                          staticClass: "backToHt",
                          on: { click: _vm.backToHt },
                        },
                        [_vm._v("返回后台")]
                      )
                    : _c("div", { staticClass: "username" }, [
                        !_vm.icveLoginName
                          ? _c("div", { staticClass: "user" }, [
                              _c(
                                "p",
                                {
                                  staticClass: "userLoginName",
                                  on: { click: _vm.isLogin },
                                },
                                [_vm._v(_vm._s(_vm.userLogin.username))]
                              ),
                              _vm._v(" "),
                              _c("p", { on: { click: _vm.toRegister } }, [
                                _vm._v("| 注册"),
                              ]),
                            ])
                          : _c("div", [
                              _c(
                                "p",
                                {
                                  staticClass: "userLoginName",
                                  staticStyle: { cursor: "pointer" },
                                  on: { click: _vm.goToIcve },
                                },
                                [_vm._v(_vm._s(_vm.icveLoginName))]
                              ),
                              _vm._v(" "),
                              _c("p", { on: { click: _vm.quitIcveLogin } }, [
                                _vm._v("| 退出"),
                              ]),
                            ]),
                      ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "login" }, [
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/" ? "navActive jiaoshi" : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/", "首页")
                      },
                    },
                  },
                  [_vm._v("\n            首页\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/reNews"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/reNews", "新闻公告")
                      },
                    },
                  },
                  [_vm._v("\n            新闻公告\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive == "/allModule" ||
                      _vm.navActive == "/recommendCourse" ||
                      _vm.navActive == "/professionalTeaching" ||
                      _vm.navActive == "/boutiqueCourse" ||
                      _vm.navActive == "/virtualCourse"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/allModule", "专业与课程服务中心")
                      },
                    },
                  },
                  [_vm._v("\n            专业与课程服务中心\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/virtual"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/virtual", "虚拟仿真实训中心")
                      },
                    },
                  },
                  [_vm._v("\n            虚拟仿真实训中心\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/teacherPower"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/teacherPower", "教师能力提升中心")
                      },
                    },
                  },
                  [_vm._v("\n            教师能力提升中心\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/books"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/books", "教材资源中心")
                      },
                    },
                  },
                  [_vm._v("\n            教材资源中心\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/communityEducation" ||
                      _vm.navActive == "/oldAgeEducation" ||
                      _vm.navActive == "/collegeEngineers" ||
                      _vm.navActive == "/learning"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("/communityEducation", "首都特色教育")
                      },
                    },
                  },
                  [_vm._v("\n            首都特色教育\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/books2"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("", "办事大厅")
                      },
                    },
                  },
                  [_vm._v("\n            办事大厅\n          ")]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "backToHt newbtn" }, [
                _c(
                  "div",
                  {
                    class:
                      _vm.navActive === "/dashboard"
                        ? "navActive jiaoshi"
                        : "jiaoshi",
                    on: {
                      click: function ($event) {
                        return _vm.goPath("", "职位分类")
                      },
                    },
                  },
                  [_vm._v("\n            职位分类\n          ")]
                ),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _vm._m(2),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "countryLogin",
          attrs: {
            visible: _vm.loginDialog,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
            width: "20%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.loginDialog = $event
            },
          },
        },
        [
          _c("div", { staticClass: "l_W" }, [
            _vm.boxLoginShow
              ? _c(
                  "div",
                  { staticClass: "boxLogin" },
                  [
                    _c("h5", { staticClass: "infoLogin" }, [
                      _vm._v("账号登录"),
                    ]),
                    _vm._v(" "),
                    _vm.phoneTipShow
                      ? _c("p", { staticClass: "phoneTip" }, [
                          _c("i", { staticClass: "el-icon-warning-outline" }),
                          _vm._v(" 请输入手机号\n        "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-form",
                      {
                        ref: "userMsg",
                        attrs: { model: _vm.userMsg, rules: _vm.userRules },
                      },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "username" } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "medium",
                                "prefix-icon": "el-icon-mobile-phone",
                                placeholder: "请输入账号",
                              },
                              model: {
                                value: _vm.userMsg.username,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userMsg, "username", $$v)
                                },
                                expression: "userMsg.username",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          { attrs: { prop: "password" } },
                          [
                            _c("el-input", {
                              attrs: {
                                "prefix-icon": "el-icon-lock",
                                type: "password",
                                placeholder: "请输入密码",
                              },
                              model: {
                                value: _vm.userMsg.password,
                                callback: function ($$v) {
                                  _vm.$set(_vm.userMsg, "password", $$v)
                                },
                                expression: "userMsg.password",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "loginBtn",
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.login("userMsg")
                          },
                        },
                      },
                      [_vm._v("登录")]
                    ),
                    _vm._v(" "),
                    _c("br"),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "agreementBox" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.checked,
                      callback: function ($$v) {
                        _vm.checked = $$v
                      },
                      expression: "checked",
                    },
                  },
                  [_vm._v("我已阅读并同意")]
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openUserService("/userService")
                      },
                    },
                  },
                  [_vm._v("《国家职业教育智慧教育平台用户协议》")]
                ),
                _vm._v(" "),
                _c(
                  "el-link",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.openUserService("/userServiceTwo")
                      },
                    },
                  },
                  [_vm._v("《国家职业教育智慧教育平台隐私协议》")]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "xz",
          attrs: {
            visible: _vm.isShow,
            "modal-append-to-body": true,
            "close-on-click-modal": false,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isShow = $event
            },
          },
        },
        [
          _c("h5", [_vm._v("欢迎登录，选择进入系统")]),
          _vm._v(" "),
          _c(
            "ul",
            _vm._l(_vm.xzList, function (i, j) {
              return _c(
                "li",
                {
                  key: j,
                  on: {
                    click: function ($event) {
                      return _vm.tiaozhuan(i.url)
                    },
                  },
                },
                [_vm._v("\n        " + _vm._s(i.name) + "\n      ")]
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "LLogo" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/image/toplogo.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "CLogo" }, [
      _c("img", {
        attrs: { src: require("@/assets/img/image/topRight.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "footerWarp" }, [
      _c("div", { staticClass: "footer" }, [
        _c("div", { staticClass: "leftFooter" }, [
          _c("p", [_vm._v("Copyright© 2022 北京职业教育智慧教育在线学习平台")]),
          _vm._v(" "),
          _c("p", [_vm._v("网站运维：高等教育出版社")]),
          _vm._v(" "),
          _c("p", [_vm._v("咨询电话：010-58556197（工作日 8:30-17:00）")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("京ICP备 12020869号-19 京公网安备 11010202007836号"),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }